import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Event illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-event',

    shadow: true,
})
export class EsIllustrationEvent {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 550.9 844.8"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M292.1 44.9 292.1 44.9 292.1 44.9 292.1 44.9z"
                />
                <rect height="8.9" x="546.8" y="472.9" fill="#fff" />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M147.1 128.7 147.1 128.7 147.1 128.7 147.1 128.7z"
                />
                <path
                    fill="#fff"
                    d="M546.6 635.4 546.6 636.1 546.6 635.4 546.6 635.4z"
                />
                <rect height="4.4" x="546.6" y="681.5" fill="#fff" />
                <rect height="4.5" x="185.4" y="158.3" fill="#fff" />
                <path
                    fill="#fff"
                    d="M3.9 55.8 93.3 4.8 547 265 546.8 787.4 455.1 841 3.9 581.3 3.9 55.8z"
                />
                <path
                    fill="#bbdefb"
                    fill-rule="evenodd"
                    d="M547 265 546.8 787.4 455.1 841 455.3 316.4 547 265z"
                />
                <path
                    fill="#1a4e85"
                    d="M415.4 339.8c.2.3.3.6.3 1v427.7c0 .7-.4 1.3-1 1.7s-1.3.3-1.9 0L44.4 557.4c-.6-.3-1-1-1-1.7V128.1c0-.7.4-1.3 1-1.7s1.3-.3 1.9 0L414.6 339c.3.2.5.4.7.7Zm-3.6 425.3V341.8L47.3 131.4v423.2L411.8 765Z"
                />
                <path
                    fill="#1a4e85"
                    d="M550.4 263.1c.3.6.5 1.2.5 1.9l-.5 523.2c0 1.4-.7 2.6-1.9 3.3l-91.1 52.6c-1.2.7-2.7.7-3.8 0L1.9 583.4c-1.2-.7-1.9-2-1.9-3.3V55.7c0-1.4.7-2.6 1.9-3.3L91.8.5c1.2-.7 2.7-.7 3.8 0L549 261.7c.6.3 1.1.8 1.4 1.4ZM542.7 786l.5-518.7L93.7 8.3l-86 49.6v520l447.7 258.5 87.3-50.4Z"
                />
                <path
                    fill="#1a4e85"
                    d="M453.7 315.4 455.3 316.4 453.7 315.4 453.7 315.4z"
                />
                <path
                    fill="#1a4e85"
                    d="m527.7 273.9-73.6 41.3c-.1 0-.3.2-.4.3l1.6 1 73.4-41.2c-.4-.5-.7-.9-1.1-1.4Z"
                />
                <path
                    fill="#1a4e85"
                    d="M453.7 315.4c-.1.1-.2.3-.3.4-.2.3-.3.6-.3 1v496.6h3.8V318l73.1-41c-.5-.6-.9-1.1-1.3-1.7l-73.4 41.2-1.6-1Z"
                />
                <path
                    fill="#1a4e85"
                    d="M455.3 316.4 528.7 275.2 528.7 275.2 455.3 316.4z"
                />
                <path
                    fill="#1a4e85"
                    d="M320.1 238.3 455.3 316.4 320.1 238.3 320.1 238.3z"
                />
                <path
                    fill="#1a4e85"
                    d="m527.7 273.9-72.6 40.7-134.3-77.5-.6 1.2 135.2 78.1 73.4-41.2c-.4-.5-.7-.9-1.1-1.4Z"
                />
                <path
                    fill="#1a4e85"
                    d="M320.1 238.3c-.4.7-.7 1.5-1.1 2.2l135 78c.6.3 1.3.3 1.9 0l74.1-41.6c-.5-.6-.9-1.1-1.3-1.7l-73.4 41.2-135.2-78.1Z"
                />
                <path
                    fill="#1a4e85"
                    d="M455.3 316.4 528.7 275.2 528.7 275.2 455.3 316.4z"
                />
                <path
                    fill="#1a4e85"
                    d="M26.4 67.1c-.2.4-.5.8-.7 1.2l157.8 91.1v-1.6L26.4 67.1Z"
                />
                <path
                    fill="#1a4e85"
                    d="M183.4 159.4 25.7 68.3l-1.2 2.1 158 91.2c.4-.7.8-1.4 1.2-2.2h-.2Z"
                />
                <rect height=".2" x="183.5" y="159.4" fill="#1a4e85" />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 550.9 844.8"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M292.1 44.9 292.1 44.9 292.1 44.9 292.1 44.9z"
                />
                <rect height="8.9" x="546.8" y="472.9" fill="#fff" />
                <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M147.1 128.7 147.1 128.7 147.1 128.7 147.1 128.7z"
                />
                <path
                    fill="#fff"
                    d="M546.6 635.4 546.6 636.1 546.6 635.4 546.6 635.4z"
                />
                <rect height="4.4" x="546.6" y="681.5" fill="#fff" />
                <rect height="4.5" x="185.4" y="158.3" fill="#fff" />
                <path
                    fill="#ced4db"
                    d="M3.9 55.8 93.3 4.8 547 265 546.8 787.4 455.1 841 3.9 581.3 3.9 55.8z"
                />
                <path
                    fill="#09264a"
                    fill-rule="evenodd"
                    d="M547 265 546.8 787.4 455.1 841 455.3 316.4 547 265z"
                />
                <path
                    fill="#09264a"
                    d="M415.4 339.8c.2.3.3.6.3 1v427.7c0 .7-.4 1.3-1 1.7s-1.3.3-1.9 0L44.4 557.4c-.6-.3-1-1-1-1.7V128.1c0-.7.4-1.3 1-1.7s1.3-.3 1.9 0L414.6 339c.3.2.5.4.7.7Zm-3.6 425.3V341.8L47.3 131.4v423.2L411.8 765Z"
                />
                <path
                    fill="#fff"
                    d="M550.4 263.1c.3.6.5 1.2.5 1.9l-.5 523.2c0 1.4-.7 2.6-1.9 3.3l-91.1 52.6c-1.2.7-2.7.7-3.8 0L1.9 583.4c-1.2-.7-1.9-2-1.9-3.3V55.7c0-1.4.7-2.6 1.9-3.3L91.8.5c1.2-.7 2.7-.7 3.8 0L549 261.7c.6.3 1.1.8 1.4 1.4ZM542.7 786l.5-518.7L93.7 8.3l-86 49.6v520l447.7 258.5 87.3-50.4Z"
                />
                <path
                    fill="#1a4e85"
                    d="M453.7 315.4 455.3 316.4 453.7 315.4 453.7 315.4z"
                />
                <path
                    fill="#1a4e85"
                    d="m527.7 273.9-73.6 41.3c-.1 0-.3.2-.4.3l1.6 1 73.4-41.2c-.4-.5-.7-.9-1.1-1.4Z"
                />
                <path
                    fill="#09264a"
                    d="M453.7 315.4c-.1.1-.2.3-.3.4-.2.3-.3.6-.3 1v496.6h3.8V318l73.1-41c-.5-.6-.9-1.1-1.3-1.7l-73.4 41.2-1.6-1Z"
                />
                <path
                    fill="#1a4e85"
                    d="M455.3 316.4 528.7 275.2 528.7 275.2 455.3 316.4z"
                />
                <path
                    fill="#1a4e85"
                    d="M320.1 238.3 455.3 316.4 320.1 238.3 320.1 238.3z"
                />
                <path
                    fill="#09264a"
                    d="m527.7 273.9-72.6 40.7-134.3-77.5-.6 1.2 135.2 78.1 73.4-41.2c-.4-.5-.7-.9-1.1-1.4Z"
                />
                <path
                    fill="#09264a"
                    d="M320.1 238.3c-.4.7-.7 1.5-1.1 2.2l135 78c.6.3 1.3.3 1.9 0l74.1-41.6c-.5-.6-.9-1.1-1.3-1.7l-73.4 41.2-135.2-78.1Z"
                />
                <path
                    fill="#09264a"
                    d="M455.3 316.4 528.7 275.2 528.7 275.2 455.3 316.4z"
                />
                <path
                    fill="#09264a"
                    d="M26.4 67.1c-.2.4-.5.8-.7 1.2l157.8 91.1v-1.6L26.4 67.1Z"
                />
                <path
                    fill="#09264a"
                    d="M183.4 159.4 25.7 68.3l-1.2 2.1 158 91.2c.4-.7.8-1.4 1.2-2.2h-.2Z"
                />
                <rect height=".2" x="183.5" y="159.4" fill="#1a4e85" />
            </svg>
        );
    }
}
